import { useOutletContext } from "react-router-dom";
import DashOnuComponent from "../../../../components/dashOnuComponent";

export default function DashOnu() {
  const {
    filterData,
    handleAplicarZoom,
    setLoadingCronometro,
    setCounter,
    selectTime,
    optionsTime,
    startCronometro,
    controllerDashboard,
    setControllerDashboard,
    api,
    stopCronometro,
  } = useOutletContext();
  const availableItemsUrl = "/zabbix/dash/schemaKeys";
  const serieTemporalUrl = "/zabbix/serieTemporal";
  const vlanFallbackUrl = "/interno/find/circuitVlan";

  return DashOnuComponent({
    filterData,
    handleAplicarZoom,
    setLoadingCronometro,
    setCounter,
    selectTime,
    optionsTime,
    startCronometro,
    controllerDashboard,
    setControllerDashboard,
    api,
    stopCronometro,
    availableItemsUrl,
    serieTemporalUrl,
    vlanFallbackUrl,
  });
}
